import { NavActions } from 'app/shared/page-parts/BottomNav';
import { Obj } from 'app/tools/general.types';
import { getActions, getReducers, keyByName } from 'app/tools/utils';
import { combineReducers } from 'redux';
import createBasicSlice, {
  createUpdateSlice,
} from './create-basic-slice';

export const contextSlices = [
  createBasicSlice(
    'fullScreen',
    false as boolean | 'showHeader' | 'showFooter'
  ),
  createBasicSlice('menuOpen', false),
  createBasicSlice('sideMenuNavItems', true),
  createBasicSlice('navActions', null as NavActions | null),
  createBasicSlice('fetchifyLoaded', false),
  createBasicSlice('appOnline', true as boolean | 'backOnline'),
  createUpdateSlice(
    'pageTitles',
    {} as Obj<string>,
    (s, payload: Obj<string>) => ({ ...s, ...payload })
  ),
];

const contextRedux = keyByName(contextSlices);

export const contextActions = getActions(contextRedux);
export const contextReducer = combineReducers(
  getReducers(contextRedux)
);
